import {mediaBreakpointDown} from "../utilities/MediaBreakpoints";
import $ from "jquery";
class StickyHeader {
    headerElement;
    observerElement;

    constructor({element, observerElement}) {
        this.headerElement = element;
        this.observerElement = observerElement;
        this.main();
    }

    main() {
        // this.renderIntersectElement();
        // this.setupObserver();
    }


    setupObserver() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.headerElement.classList.remove('sticky-enter');
                    this.headerElement.classList.add('sticky-leave');
                    setTimeout(() => this.headerElement.classList.remove('sticky-leave'), 200);
                } else {
                    this.headerElement.classList.add('sticky-enter');
                    this.headerElement.classList.remove('sticky-leave');
                }
            });

        }, {
            root: null,
            rootMargin: "0px",
            threshold: 1.0,
        });
        observer.observe(document.getElementById('intersect'));
    }

    renderIntersectElement() {
        const intersectElement = document.createElement('div');
        intersectElement.id = 'intersect';
        this.observerElement.after(intersectElement);
    }
}

export default function useStickyHeader() {
    if (mediaBreakpointDown('lg')) return;
    $(window).scroll(function() {
        if ($(this).scrollTop() > 50) {
            $('#appHeader').addClass('sticky-enter');
        } else {
            $('#appHeader').removeClass('sticky-enter');
        }
    });
    // const intersectionElement = document.querySelector('.hero-base');
    // const headerElement = document.querySelector('header#appHeader');
    // new StickyHeader({
    //     element: headerElement,
    //     observerElement: intersectionElement !== null ? intersectionElement : headerElement
    // })
}
